import React from 'react';
import { Alert } from "react-bootstrap";

const SpellError = ({ spellData, className }) => {
  const { HtmlDocument, Suggestions, SuggestionCount, result } = spellData || {};
  let errorText = '';

  // handle data for VSpell API
  if (HtmlDocument && Suggestions.length) {
    const doc = new DOMParser().parseFromString(HtmlDocument, "text/html");
    const suggestion = doc.querySelectorAll('.suggestion');
    if (suggestion.length) {
      suggestion.forEach((s, index) => {
        if (Suggestions[index]) {
          let endLine = ', ';
          if ((index + 1) === Suggestions.length) {
            endLine = '.';
          }
          errorText = errorText.concat(s.innerHTML, endLine);
        }
      });
    }
  }

  // handle data for Viettel API
  if (result && result.suggestions.length > 0) {
    let originalTexts = '';
    let suggestions = '';

    result.suggestions.forEach((s, index) => {
      let endLine = ', ';
      if ((index + 1) === result.suggestions.length) {
        endLine = '.';
      }
      originalTexts = originalTexts.concat(s.originalText, endLine);
      suggestions = suggestions.concat(s.suggestion, endLine);
    });

    errorText = originalTexts;
  }

  return (
    <>
      {errorText &&
        <div className={`text-danger ${className}`}>
          <Alert variant="warning">
            <Alert.Heading as="h6">Có lỗi chính tả</Alert.Heading>
            <p className="mb-0">Từ lỗi: {errorText}</p>            
          </Alert>
        </div>
      }
    </>
  )
}

export default SpellError;
